// extracted by mini-css-extract-plugin
export default {"container":"MainPageCharts_container__shzVu","row":"MainPageCharts_row__0s5BJ"};